import type { RepFieldAudit } from "@repo/models";
import type { GridList } from "@repo/ui";
import type { AxiosRequestConfig } from "axios";

import type { FieldAuditsFilter } from "../pages/fieldAudits/types";

import { BaseController } from "./baseController";
import { BaseGridApi } from "./baseGridApi";

export const controller = "FieldAudits";

export default class FieldAuditsApi {
	static Get = BaseController.GetFn(controller);
	static Post = BaseController.PostFn(controller);

	static getFieldAudits(filter: FieldAuditsFilter, config?: AxiosRequestConfig) {
		return FieldAuditsApi.Get<GridList<RepFieldAudit>>("GetFieldAudits", filter, config);
	}

	static getFieldAuditTypes() {
		return FieldAuditsApi.Get<{ Value: number; Text: string }[]>("GetFieldAuditTypes");
	}

	static getLocations() {
		return FieldAuditsApi.Get<{ LocationId: number; Name: string }[]>("GetLocations");
	}

	static importFieldAudit(url: string) {
		return FieldAuditsApi.Post<void>("Import", {}, { url });
	}

	static loadGridSettings() {
		return BaseGridApi.loadGridSettings(controller, "Field Audits");
	}

	static saveGridSettings(settingsJson: string) {
		return BaseGridApi.saveGridSettings(controller, "Field Audits", settingsJson);
	}

	static getGridColumns() {
		return BaseGridApi.getGridColumns<any>(controller, "FieldAudits");
	}
}
